import React from "react";

import type { NormerendeProdukterProps } from "../../../../lib/modules/listSearchUtils/index.d";
import Base from "../Base/Base";

export default function NormerendeProdukter(props: Readonly<NormerendeProdukterProps>) {
  const {
    contentTypeDisplayname,
    sisteFagligeEndring,
    localizedForListSearch
  } = props;

  return (
    <Base showPdfIcon {...props}>
      { contentTypeDisplayname && <p className="text-neutral-subtle">{contentTypeDisplayname}</p> }
      { sisteFagligeEndring
        && (
          <time dateTime={sisteFagligeEndring}>
            <div className="flex nt-flex-col tablet:nt-flex-row">
              <span className="mr-xxs">{localizedForListSearch?.sisteFagligeEndring ?? "Siste faglige endring:"}</span>
              <span>{sisteFagligeEndring}</span>
            </div>
          </time>
        )}
    </Base>
  );
}
